import { forwardRef, useContext } from 'react';
import { Calendar } from 'primereact/calendar';
import AddressChildren from './AddressChildren';
import { TwinTab } from './TwinTab';
import { ParameterContext } from '../contexts/ParameterContext';
import { AuthContext } from '../contexts/AuthContext';
import { AddressContext } from '../contexts/AddressContext';



export const ChildDataTextSetAddresses = forwardRef(({ formData, handleChange, isEdit, onBlurValidate, errors, isDropdownOpen, toggleDropDown, onBlurTwins, addTwin, removeTwin }, ref) => {
    const { parameters } = useContext(ParameterContext);
    const { user } = useContext(AuthContext);
    const { addressResidence } = useContext(AddressContext);

    //addressResidence
    let dirDisableChildData;

    if (parameters && parameters.nomParameters) {
        const dirDisableChildDataParam = parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');

        dirDisableChildData = dirDisableChildDataParam ? dirDisableChildDataParam.value : 2
    } else {
        dirDisableChildData = 2;
    }

    return (
        <>
            <div ref={ref} className="htext_ch">Данни за детето</div>

            <div className="children_data p-3-mob">

                <div className="w-100 d-flex gap-3 flex-col-mob">

                    <div className="flex-col flex-wrap w-50 w-100-mob">

                        <div className="labels_rb" id="basic-addon1">
                            ЕГН*&nbsp;
                            <input
                                type="radio"
                                id="egncid"
                                name="childIsEgn"
                                value="1"
                                checked={formData.childIsEgn == '1'}
                                onChange={handleChange}
                                defaultChecked
                                disabled={isEdit}
                            />
                            &nbsp;&nbsp;&nbsp;ЛНЧ*&nbsp;
                            <input
                                type="radio"
                                id="lnccid"
                                name="childIsEgn"
                                value="0"
                                checked={formData.childIsEgn == '0'}
                                onChange={handleChange}
                                onBlur={onBlurValidate}
                                disabled={isEdit}
                            />
                        </div>
                        <div className="labels_rb d-flex gap-2 w-100 flex-wrap" id="basic-addon1">
                            <input
                                type="text"
                                name="childEgn"
                                className={` form-control round_buttons`}
                                placeholder={formData.childIsEgn == 1 ? 'ЕГН на дете' : 'ЛНЧ на дете'}
                                value={formData.childEgn}
                                onChange={handleChange}
                                onBlur={onBlurValidate}
                                disabled={isEdit}
                            />

                            {formData.childIsEgn == 0 &&
                                <Calendar
                                    showButtonBar
                                    locale='bg'
                                    className="fade prime-dropdown-heigth w-100"
                                    name="childLnchDate"
                                    value={formData.childLnchDate || null}
                                    onChange={handleChange}
                                    showIcon
                                    placeholder='Дата на раждане'
                                />
                            }
                        </div>
                        {errors.childEgn && <label className="text-danger w-100 ">{errors.childEgn}</label>}
                        {errors.validAddressResidance && <label className="text-danger w-100 ">{errors.validAddressResidance}</label>}
                        {errors.childLnchDate && <label className="text-danger w-100 ">{errors.childLnchDate}</label>}

                    </div>

                    <div className="flex-col flex-wrap w-50 w-100-mob">
                        <div className="labels_rb w-100" id="basic-addon1">  Три имена*:</div>
                        <input
                            type="text w-100"
                            name="childName"
                            className={` form-control round_buttons capital`}
                            placeholder="Полето трябва да е изписано на кирилица"
                            value={formData.childName}
                            onChange={handleChange}
                            onBlur={onBlurValidate}
                            disabled={isEdit || (dirDisableChildData == 1 && user.role == 'Director' && addressResidence.length > 0)}
                        />
                    </div>

                </div>

                <AddressChildren formData={formData} handleChange={handleChange} isDropdownOpen={isDropdownOpen} toggleDropDown={toggleDropDown} isMunicipality={true} isEdit={isEdit} />

                <div className="w-100 d-flex gap-3 mt-3 flex-wrap">
                    {formData.twins.map((x, i) => <TwinTab twin={x} formData={formData} index={i} handleChange={handleChange} onBlurTwins={onBlurTwins} onBlurValidate={onBlurValidate} errors={errors} />)}
                </div>

                <div className="w-100 d-flex gap-3">

                    <div className="flex-col flex-wrap mt-3 ">
                        <button id="" className="btn btn-primary mb-3 mt-3" onClick={addTwin}>Добави близнак</button>
                    </div>

                    <div className="flex-col flex-wrap mt-3">
                        {formData.twins.length > 0 && (
                            <button className="btn btn-danger mb-3 mt-3" onClick={removeTwin}>
                                Изтрий последния близнак
                            </button>
                        )}
                    </div>

                </div>

            </div>
        </>
    )
})